<template>
    <td>
        <div class="d-flex align-center">
            <strong :class="getClass()">{{ value }}</strong>
            <v-tooltip right>
                <template v-slot:activator="{ on }">
                    <v-icon v-on="on" :color="getColor()">{{ icon }}</v-icon>
                </template>
                <span>{{ $t('relTripPassangers.headerPdf.average') }}: {{ medium }}</span>
            </v-tooltip>
        </div>
    </td>
</template>

<script>
export default {
    name: "MediumItem",
    props: {
        value: {
            type: Number,
            required: true
        },
        medium: {
            type: Number
        }
    },
    computed: {
        icon() {
            if (this.medium === null) {
                return null
            }

            if (this.value > this.medium) {
                return "mdi-menu-up";
            }

            if (this.value < this.medium) {
                return "mdi-menu-down";
            }

            return "mdi-minus"
        }
    },
    methods: {
        getClass() {
            return {
                over_medium: this.value > this.medium,
                on_medium: this.value == this.medium,
                under_medium: this.value < this.medium
            };
        },
        getColor() {
            if (this.value > this.medium) {
                return "green";
            }

            if (this.value < this.medium) {
                return "red";
            }

            return "black";
        }
    }
}
</script>

<style>
.over_medium {
    color: green;
}

.on_medium {
    color: black;
}

.under_medium {
    color: red;
}
</style>